import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OrganizationProvider } from './contexts/OrganizationContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

import Dashboard from './components/Dashboard';
import AddEndpointForm from './components/AddEndpointForm';
import ServiceDetail from './pages/ServiceDetail';

// No login or signup pages — all access comes through portal SSO
// pulse.amslerlabs.com is not a standalone app

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <OrganizationProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/admin" replace />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/add-endpoint"
              element={
                <ProtectedRoute>
                  <AddEndpointForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/service/:serviceId"
              element={
                <ProtectedRoute>
                  <ServiceDetail />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </OrganizationProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;